/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Reseller_Pricing_Enabled_LabelInputs */

const id_reseller_pricing_enabled_label = /** @type {(inputs: Reseller_Pricing_Enabled_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktifkan ${i?.tld}`)
};

const en_reseller_pricing_enabled_label = /** @type {(inputs: Reseller_Pricing_Enabled_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sell ${i?.tld}`)
};

/**
* | output |
* | --- |
* | "Sell {tld}" |
*
* @param {Reseller_Pricing_Enabled_LabelInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_enabled_label = /** @type {((inputs: Reseller_Pricing_Enabled_LabelInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Enabled_LabelInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_enabled_label(inputs)
	return id_reseller_pricing_enabled_label(inputs)
});